export { default as TexthtmlEditorModule } from './TexthtmlEditorModule';
